import compose from 'compose-function';

// import withMantine from './with-mantine';
import withReactQuery from './with-react-query';
import withRouter from './with-routers';

const withProviders = compose(withRouter, withReactQuery);

export default withProviders;
